'use client';

import dynamic from 'next/dynamic';
import { TComponent } from '@/lib/contentstack-sdk/types/component';

// Dynamically import components with ssr: false
const OrMappingToolCS = dynamic(
  () =>
    import('@/components/organisms/or-mapping-tool/or-mapping-tool.cms').then(
      (mod) => mod.OrMappingToolCS,
    ),
  { ssr: false },
);

const OrLeadGenFormCs = dynamic(
  () =>
    import('@/components/organisms/or-lead-gen-form/or-lead-gen-form.cms').then(
      (mod) => mod.OrLeadGenFormCs,
    ),
  { ssr: false },
);

export default function RenderClientOnlyComponents({
  body,
}: {
  body: TComponent;
}) {
  switch (body._content_type_uid) {
    case 'mapping_tool':
      return <OrMappingToolCS block={body} />;
    case 'lead_generation_form':
      return <OrLeadGenFormCs {...body} />;
    default:
      return null;
  }
}
